<template>
  <div>
    <v-container fluid style="padding: 25px; width: 100%; height: 100%">
      <v-card flat>
        <v-toolbar flat class="zero_padding_toolbar">
          <h3>{{ $t("_mayor.contact").toLocaleUpperCase(lang) }}</h3>
        </v-toolbar>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            value="John"
            :label="$t('_contact.phone')"
            :readonly="readonly === editPhone"
            filled
            :append-icon="editPhone ? 'edit' : 'done'"
            @click:append="editPhoneNum"
          ></v-text-field>
          <v-text-field
            value="John"
            :label="$t('_contact.e-mail')"
            :readonly="readonly === editMail"
            filled
            :append-icon="editMail ? 'edit' : 'done'"
            @click:append="editEmail"
          ></v-text-field>
          <v-textarea
            value="John"
            :label="$t('_contact.address')"
            :readonly="readonly === editAddress"
            filled
            :append-icon="editAddress ? 'edit' : 'done'"
            @click:append="editAddressLoc"
            rows="3"
          ></v-textarea>

          <v-btn class="mr-4" color="warning" @click="readonly = false">
            Düzenle
          </v-btn>

          <v-btn :disabled="!valid" color="success" @click="readonly = true">
            Kaydet
          </v-btn>
        </v-form>
      </v-card>
    </v-container>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      elevation="24"
      :color="snackColor"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Kapat
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      tab: null,
      valid: false,
      categoryName: "",
      categoryRules: [(v) => !!v || $t("_rules.categoryRules")],
      dialog: false,
      valid: false,
      snackbar: false,
      snackColor: "",
      snackText: "",
      x: null,
      y: null,
      mode: null,
      timeout: 1500,
      loadTable: true,
      readonly: true,
      editPhone: true,
      editMail: true,
      editAddress: true,
    };
  },
  created() {
    // this.filter = JSON.parse(JSON.stringify(this.emptyFilter));
    this.getIssueCategories();
  },
  computed: {
    ...mapGetters({ issueCategories: "issues/issueCategories" }),
    ...mapGetters({ language: "app/language" }),

    headers() {
      return [
        {
          text: this.$t("_issues.categoryName"),
          sortable: true,
          value: "name",
        },
        {
          text: this.$t("_incident.actions"),
          value: "actions",
          sortable: false,
          align: "right",
          divider: false,
          width: 130,
        },
      ];
    },

    perPageText() {
      if (this.language == "en_US") {
        return "Rows per page:";
      }
      return "Sayfa başına satır:";
    },
  },
  methods: {
    editPhoneNum() {
      this.editPhone = !this.editPhone;
      if (this.editPhone == true){
          this.snackbar = true;
          this.snackColor = "success";
          this.snackText = "Telefon Numarası Güncellendi!";
          this.x = "center";
          this.y = "bottom";
      }
    },
    editEmail() {
      this.editMail = !this.editMail;
      if (this.editMail == true){
          this.snackbar = true;
          this.snackColor = "success";
          this.snackText = "E-mail Güncellendi!";
          this.x = "center";
          this.y = "bottom";
      }
    },
    editAddressLoc() {
      this.editAddress = !this.editAddress;
      if (this.editAddress == true){
          this.snackbar = true;
          this.snackColor = "success";
          this.snackText = "Adres Güncellendi!";
          this.x = "center";
          this.y = "bottom";
      }
    },
  },
  watch: {
    language: function () {
      console.log("lang changed");
      this.getIssueCategories();
    },
  },
};
</script>
<style>
.zero_padding_toolbar .v-toolbar__content {
  padding: 0x !important;
}
</style>